import { render, staticRenderFns } from "./CandidateRevenueTab.vue?vue&type=template&id=b6b39fdc&"
import script from "./CandidateRevenueTab.vue?vue&type=script&lang=js&"
export * from "./CandidateRevenueTab.vue?vue&type=script&lang=js&"
import style0 from "./CandidateRevenueTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports